import moment from 'moment';
import Vue from 'vue';
import { validationMessage } from 'vuelidate-messages';
import VueConfetti from 'vue-confetti';
import { call, get, sync } from "vuex-pathify";

Vue.use(VueConfetti)

const formMessages = {
  unique: () => 'Registration must be unique',
  requiredVehicle: () => 'Required',
  requiredPassenger: () => 'Required',
  requiredInbound: () => 'Inbound flight number is required for this product',
  required: () => 'Required',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters`,
  minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters`,
  email: () => `Invalid email`,
  sameAsPassword: () => `Passwords do not match`,
  goodPassword: () => `Your password must contain at least (1) lowercase and (1) uppercase letter`
}

const globals = {
  data() {
    return {
      siteName: process.env.VUE_APP_SITE_NAME || 'SkyParkSecure',
      distanceUnit: this.$t('general.miles'),
      mapKey: process.env.VUE_APP_GOOGLE_MAPS || '',
      currency: process.env.VUE_APP_CURRENCY || '£',
      timeoutLimit: process.env.VUE_APP_QUOTE_TIMEOUT_MINS || 60,
      terms: process.env.VUE_APP_PAYMENT_TERMS || 'https://www.skyparksecure.com/terms-and-conditions',
      facebook: process.env.VUE_APP_FACEBOOK,
      supportEmail: process.env.VUE_APP_SUPPORT_EMAIL || 'noreply@skyparksecure.com',
      cdn: process.env.VUE_APP_CDN || 'web-assets-1.skyparksecure.com',
      fallbackImage: `${process.env.VUE_APP_CDN || 'web-assets-1.skyparksecure.com'}/images/New-Logo-Coming-Soon.png`,
      loungeFallbackImage: `${process.env.VUE_APP_CDN || 'web-assets-1.skyparksecure.com'}/images/400x400-New-Logo-Coming-Soon-Square.png`,
      rentalCarsId: `${process.env.VUE_APP_RENTALCARS_ID || ''}`,
      showPaypal: (process.env.VUE_APP_ENABLE_PAYPAL === 'true') || false,
    }
  }
};

const quoteGen = {
  data() {
    return {
      params: null,
      resultsCat: [
        'airportparking',
        'airporthotel',
        'airportlounge'
      ],
      loading: true,
    }
  },
  methods: {
    updateQuote: call("quote/updateQuote"),
    clearQuote: call("quote/clearQuote"),
    loadUpgrades: call("upgrades/getUpgrades"),
  },
  computed: {
    requotedHotel: get("results/requotedHotel"),
    mixinQuote: sync("quote")
  },
  watch: {
    requotedHotel: function(value) {
      this.mixinQuote.hotelToParking = true;
      if(value) this.$router.replace({ path: 'airportparking-results', query: this.mixinQuote }).catch(() => {});
    }
  },
  created() {

    this.loading = true;

    let newTimestamp = new Date();
    let upgrades = (process.env.VUE_APP_UPGRADES === 'true') || false;

    // serialize
    this.params = this.$route.query;

    this.params.referrer = this.params.referrer ? this.params.referrer.split('?')[0] : '';
    this.params.agent =  Array.isArray(this.params.agent) ? this.params.agent[0] : this.params.agent;
    this.params.promo =  Array.isArray(this.params.promo) ? this.params.promo[0] : this.params.promo;

    this.params = JSON.stringify(this.params)

    // check for params
    if(Object.keys(this.$route.query).length > 0) {

      if(this.resultsCat.indexOf(this.mixinQuote.category) > -1) {

        // parse and push to store
        this.updateQuote({...JSON.parse(this.params), _timestamp: newTimestamp }).then(() => {

          this.load("silent").then(() => {
            this.loading = false;
            if(upgrades) this.loadUpgrades({ agent: 'Lounges', category: 'airportlounge', adults: 1 });
          })
        });
      }
    } else {
      this.load().then(() => {
        this.loading = false;
        if(upgrades) this.loadUpgrades({ agent: 'Lounges', category: 'airportlounge', adults: 1 });
      })
    }
  }
};

const format = {
  methods: {
    getTimeFromNow(dateTime) {
      return moment(dateTime).fromNow();
    },
    dateAtTime(date, time) {
      return `${moment(date).format('ddd Do MMMM YYYY')} ${this.$t('payment.basket.at')} ${moment(time, 'HH:mm').format('HH:mm')}`;
    },
    formatDate(date, format = 'YYYY-MM-DD') {
      return `${moment(date).format(format)}`;
    },
    terminalShorten(value) {
      return value
        .toLowerCase()
        .replace('terminal ', 'T')
        .replace('terminal', 'T')
        .replace('Tnorth', 'North')
        .replace('Tsouth', 'South')
        .replace('Tmain', 'Main')
    },
    shortenName(value = '', airport = '') {
      return value.replace(airport, '').replace('Airport -', '')
    },
    prettyCategory(category) {
      let types = {
        airportparking: 'Airport parking',
        airporthotel: 'Airport hotel',
        airportlounge: 'Airport lounge'
      } 
      return types[category] || ''
    }
  },
};

const validate = {
  methods: {
    validEmail(value) {
      // eslint-disable-next-line 
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },
    validationMsg: validationMessage(formMessages)
  },
};

const load = {
  methods: {
    fakeLoad(time = process.env.VUE_APP_FAKE_LOAD_MS) {
      let loader = Vue.$loading.show({ container: null, canCancel: false });
      setTimeout(() => {
        loader.hide();
      }, time)
    },
    async stevefetti(time) {
      this.$confetti.start();

      setTimeout(() => {
        this.$confetti.stop();
        return
      }, time)
    },
  },
};

const pageview = {
  methods: {
    sendPageView() {
      window.dataLayer = window.dataLayer || [];
      // eslint-disable-next-line
      dataLayer.push({
        'event': 'pageview',
      })
    }
  }
};

export default {
  globals,
  format,
  validate,
  load,
  quoteGen,
  pageview
};